import type { CapabilityObj } from 'homey-api';

import volume_mute from '../images/button/volume_mute.svg';
import volume_up from '../images/button/volume_up.svg';
import volume_down from '../images/button/volume_down.svg';
import middle from '../images/button/middle.svg';
import windowcoverings_tilt_set_upper from '../images/slider/windowcoverings_tilt_set_upper.png';
import windowcoverings_tilt_set_lower from '../images/slider/windowcoverings_tilt_set_lower.png';
import arrow_up from '../images/button/arrow_up.svg';
import arrow_down from '../images/button/arrow_down.svg';

export function getButtonImage(capabilityId: string, capabilityObj: CapabilityObj | undefined) {
  const [actualId] = capabilityId.split('.');

  const result: {
    url: string | null;
    useIconObj: boolean;
    iconObj: any;
    iconUrl: string | null;
  } = {
    url: null,
    useIconObj: false,
    iconObj: null,
    iconUrl: null,
  };

  switch (actualId) {
    case 'volume_mute':
      result.url = volume_mute;
      break;
    case 'volume_up':
      result.url = volume_up;
      break;
    case 'volume_down':
      result.url = volume_down;
      break;
    case 'windowcoverings_tilt_up':
      result.url = windowcoverings_tilt_set_upper;
      break;
    case 'windowcoverings_tilt_down':
      result.url = windowcoverings_tilt_set_lower;
      break;
    case 'channel_up':
      result.url = arrow_up;
      break;
    case 'channel_down':
      result.url = arrow_down;
      break;
    default:
      if (capabilityObj != null && capabilityObj.iconObj != null) {
        result.url = `https://icons-cdn.athom.com/${capabilityObj.iconObj.id}.svg`;
        result.useIconObj = true;
        result.iconObj = capabilityObj.iconObj;
        break;
      }

      result.url = middle;
  }

  result.iconUrl = result.url;

  return result;
}
